/**
 * form → openingChat. O pré-chat só coleta nome, celular e aceite: o widget é
 * montado com a identidade do visitante e aberto. Quem identifica a pessoa e
 * cria o lead é o bot da Callbell, pelo celular.
 */
export type TPreChatStep = 'form' | 'openingChat';

export interface IPreChatState {
  step: TPreChatStep;
}

export type TPreChatEvent = { type: 'SUBMITTED' } | { type: 'RESTARTED' };

export const PRE_CHAT_INITIAL_STATE: IPreChatState = { step: 'form' };

export default function transitionPreChat(
  state: IPreChatState,
  event: TPreChatEvent,
): IPreChatState {
  if (event.type === 'RESTARTED') return PRE_CHAT_INITIAL_STATE;

  return state.step === 'form' && event.type === 'SUBMITTED'
    ? { step: 'openingChat' }
    : state;
}
